import { PureArticleListType, TmaEModule } from "@tm/models"

export const determineTmaOriginByContextType = (listType: PureArticleListType | undefined): TmaEModule | undefined => {
    switch (listType) {
        case "recommended-articles":
            return TmaEModule.CROSS_SELLING
        case "alternative":
            return TmaEModule.ARTICLE_DETAILS_ALTERNATIVE_ARTICLE
        default:
            return undefined
    }
}
